import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=f229f8f6&scoped=true"
import script from "./ForgetPassword.vue?vue&type=script&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgetPassword.vue?vue&type=style&index=0&id=f229f8f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f229f8f6",
  null
  
)

export default component.exports